export default __webpack_public_path__ + "static/media/weights_light.50383725.svg";